export const ID = 'bdad6ae1-97e6-4b9a-b18c-d251ca6e2356';

export const NAME = 'Units Table: Rental App';
